<mat-dialog-content class="sen-fs10 pb-2">
    <div [style.background]="generatorColor" [cpToggle]="true" [cpDialogDisplay]="'inline'"
        [(colorPicker)]="generatorColor"></div>
</mat-dialog-content>
<mat-dialog-actions class="text-center mt-4 justify-content-end">
    <button mat-raised-button color="primary" class="sen-fs10 px-4"
        (click)="closeDialogue()">{{data.buttons.cancel}}</button>
</mat-dialog-actions>